// src/api/saveMatch.ts
import { API_ENDPOINTS } from "./config";

export async function buildStatistics(season_id: string) {
  const url = API_ENDPOINTS.statistics(season_id);
  const response = await fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ season_id }),
  });
  if (!response.ok) throw new Error("Fehler beim Auslesen der Daten");
  return response.json();
}

export async function fetchStatistics(season_id: string) {
  const url = API_ENDPOINTS.statistics_by_team(season_id);
  const response = await fetch(url, {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  });
  if (!response.ok) throw new Error("Fehler beim Auslesen der Daten");
  return response.json();
}
